import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import { Nav4Recommendation } from '@post-office/placements--growth/components/nav-4-projects-section';
import {
	PlacementBackend,
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/placements--growth/nav-4-projects-section';

import { type MessageTemplateContext } from '../../../index';

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

type RenderProps = MessageTemplateContext & PlacementRenderProps;

const render = PlacementFrontend.createFrontendStage({
	type: 'render',
	validate: noValidation<RenderProps>(),
	Component: (props: RenderProps) => <Nav4Recommendation {...props} />,
});

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render,
});
